module.exports = __webpack_public_path__ + "img/preview-placeholder.d5662ab.png";